export default () => ({
  title: "DonationFormVue",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
  },
});
